<template>
  <iframe
    :src="path"
    width="640"
    height="600"
    frameborder="0"
    marginheight="0"
    marginwidth="0"
    >Indlæser…</iframe
  >
</template>

<script>
export default {
  computed: {
    path() {
      if (this.$route.path.endsWith("/jens")) {
        return "https://docs.google.com/forms/d/182jSeINcLqtjbyAiBNeJ9XLjEjs9uj1eKcGLkCX-eW8/viewform?embedded=true";
      }

      // mette liste
      return "https://docs.google.com/forms/d/e/1FAIpQLSfnXGGgJxt07k2RhiT-bugcUsZ5cZw_lClN1tSNREz4KAogvA/viewform?embedded=true";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/help/index.vue